// ** Redux Imports
/* eslint-disable */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { order } from "../../../../api/Api";

export const getAllMyRefers = createAsyncThunk(
  "appMyRefers/getAllMyRefers",
  async (query) => {
    try {
      return order.getMyRefers(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const addMyRefers = createAsyncThunk(
  "appMyRefers/addMyRefers",
  async (values) => {
    try {
      return vendor.create(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const appMyRefersSlice = createSlice({
  name: "appMyRefers",
  initialState: {
    myRefers: [],
    metaData: {},
    myRefersFetched: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllMyRefers.fulfilled, (state, action) => {
      state.metaData = action.payload?.data?.metaData;
      state.myRefers = action.payload?.data?.data;
      state.myRefersFetched = true;
    });
  },
});

export default appMyRefersSlice.reducer;
